import Editor from ".";
import { HE, IDevice } from "../types";
import { $createEl } from "../utils/domHelpers";
import EventEmitter from "./eventEmitter";

class DeviceManager {
  public devices: IDevice[] = [];
  private devicesEl: HTMLElement[] = [];
  private selectedDevice: { config?: IDevice; el?: HTMLElement } = {};

  constructor(
    private containerElem: HTMLElement,
    private ee: EventEmitter,
    private editor: Editor
  ) {}

  init() {
    this.devices = this.editor.getConfig().devices || [];
    this.loadDevices();
  }

  loadDevices() {
    this.devices.forEach((device) => {
      const deviceEl = $createEl(
        "div",
        device.icon,
        {
          id: device.name,
          ...(device.default ? { class: "selected" } : {}),
        },
        {
          click: () => this.switchDevice(device.name),
        }
      );

      this.devicesEl.push(deviceEl);
      this.containerElem.append(deviceEl);

      this.switchDevice(
        (this.devices.find((d) => d.default)?.name as string) ||
          this.devices[0].name
      );
    });
  }

  switchDevice(name: string) {
    const device = this.devicesEl.find((d) => d.id === name);

    this.selectedDevice.el?.classList.remove("selected");
    device?.classList.add("selected");
    this.selectedDevice.el = device;

    this.selectedDevice.config = this.devices.find(
      (d) => d.name === name
    ) as IDevice;

    if (this.editor.getFrame()) {
      (this.editor.getFrame() as HE).style.width =
        this.selectedDevice.config.width;
    }
  }
}

export default DeviceManager;
